import React from "react";

export default class DevErrorBoundary extends React.Component {
  componentDidCatch(error, info) {
    // This prints the component stack with file:line when source maps are working
    console.group("%cReact render error", "color:#c00;font-weight:bold");
    console.error(error);
    console.log("Component stack:");
    console.log(info.componentStack);
    console.groupEnd();
  }
  render() {
    return this.props.children;
  }
}
